import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ItemDespesaService {
  private data = null;
  private url = environment.serviceApi;
  
  constructor(public http: Http) { }

	getItensDespesa(despesaId) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/itemdespesa/' + despesaId)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
	
	criaItensDespesa(data) {
		let data_gravacao =  new Date().toISOString().substr(0, 10);
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/itemdespesa', {
				usuario_id: data.usuario_id,
				unidade_id: data.unidade_id,
				cliente_id: data.cliente_id,
				despesa_id: data.despesa_id,
				unidade_medida_id: data.item_unidadeMedida,
				item_despesa_quantidade: data.item_quantidade,
				item_despesa_valor: data.item_valor,
				item_despesa_descricao: data.item_descricao,
				item_despesa_data_gravacao: data_gravacao,
				tipo_despesa_id: data.item_despesa
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	limpaItensDespesa(despesaId){
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/itemdespesa/' + despesaId)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
